// BCS Modern: fade/slide-in for elements marked with [data-bcs-reveal].
// Without JS or with reduced motion everything stays visible (see bcs-modern.css).
(function () {
  var root = document.documentElement;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  root.classList.add('bcs-reveal-on');

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

  function watch(scope) {
    (scope || document).querySelectorAll('[data-bcs-reveal]:not(.is-visible)').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { watch(); });
  } else {
    watch();
  }
  // Theme editor: re-run when a section is added or re-rendered.
  document.addEventListener('shopify:section:load', function (event) { watch(event.target); });
})();
